module.exports = __webpack_public_path__ + "static/img/publicity-icon3.45f4914.png";


//////////////////
// WEBPACK FOOTER
// ./static/publicity-icon3.png
// module id = f7/9
// module chunks = 1